import { React, useState } from "react";
import PhoneInput, { parsePhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import CustomToast from "../Components/CustomToast/CustomToast";
import { createUserToggle } from "../Redux/Actions/dataAction";
import AdminHeader from "./AdminHeader";
import Sidebar from "./Sidebar";
import { ErrorMessage, Field, Form, Formik } from "formik";

const AddUser = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [value, setValue] = useState();
  const [isOpen, setOpen] = useState(false);

  const defaultDetails = {
    email: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
    phoneCode: "",
  };

  const schema = Yup.object().shape({
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    firstName: Yup.string().required("First name is required"),
    lastName: Yup.string().required("Last name is required"),
  });

  const doCreate = async (values) => {
    try {
      const s = parsePhoneNumber(value);
      values.phoneCode = s.countryCallingCode;
      values.phoneNumber = s.nationalNumber;
      dispatch(createUserToggle(values));
      navigate("/verify-user");
    } catch (error) {
      toast(<CustomToast type="error" message={error} />, {
        autoClose: 3000,
      });
    }
  };

  // const [isClose, setClose] = useState(false);
  const toggleOpen = () => {
    setOpen(!isOpen);
  };
  return (
    <>
      <div className="dashboard">
        <div className={isOpen ? "d-flex toggled" : "d-flex"} id="wrapper">
          <Sidebar />
          <div className="page-content">
            <nav className="navbar navbar-expand-lg navbar-light bg-transparent">
              <div className="d-flex align-items-center py-3 ps-3 d-lg-none">
                <Link onClick={toggleOpen} role="button">
                  <i
                    className="fas  fa-align-left primary-text fs-4 me-3"
                    id="menu-toggle"
                  ></i>
                </Link>
              </div>
              <AdminHeader />
            </nav>
            {/* <!-- Areas --> */}
            <div className="dashboard-page p-4">
              {/* contact form starts*/}
              <div className="contact dashboard-form">
                <div className="container">
                  <div className="contact-area">
                    <Formik
                      // enableReinitialize={true}
                      initialValues={defaultDetails}
                      validationSchema={schema}
                      onSubmit={(values) => {
                        doCreate(values);
                      }}
                    >
                      <Form>
                        {/* <div className="row"> */}

                        <div className="">
                          <div className="contact-form row">
                            <div className="mb-4 col-lg-6">
                              <label>First Name</label>
                              <Field
                                name="firstName"
                                type="text"
                                className="form-control"
                                placeholder="Enter Name"
                              />
                              <ErrorMessage
                                name="firstName"
                                render={(msg) => (
                                  <div className="text-danger">{msg}</div>
                                )}
                              />
                            </div>
                            <div className="mb-4 col-lg-6">
                              <label>Last Name</label>
                              <Field
                                name="lastName"
                                type="text"
                                className="form-control"
                                placeholder="Enter last name"
                              />
                              <ErrorMessage
                                name="lastName"
                                render={(msg) => (
                                  <div className="text-danger">{msg}</div>
                                )}
                              />
                            </div>
                            <div className="mb-4 col-lg-6">
                              <label>Email Address*</label>
                              <Field
                                name="email"
                                type="email"
                                className="form-control"
                              />
                              <ErrorMessage
                                name="email"
                                render={(msg) => (
                                  <div className="text-danger">{msg}</div>
                                )}
                              />
                            </div>
                            <div className="mb-4 col-lg-6">
                              <label>Phone*</label>
                              <PhoneInput
                                value={value}
                                onChange={setValue}
                                required
                              />
                            </div>

                            {/* <div className="send-button">
                              <button>Send</button>
                            </div> */}
                          </div>
                        </div>

                        {/* </div> */}
                        <div className="next-button text-end">
                        <Link to="/verify-user"><button>Next</button></Link>  
                        </div>
                      </Form>
                    </Formik>
                  </div>
                </div>
              </div>

              {/* contact form ends */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddUser;
